import { render, staticRenderFns } from "./digitalarchives.vue?vue&type=template&id=6bbea50e&scoped=true&"
import script from "./digitalarchives.vue?vue&type=script&lang=js&"
export * from "./digitalarchives.vue?vue&type=script&lang=js&"
import style0 from "./digitalarchives.vue?vue&type=style&index=0&id=6bbea50e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bbea50e",
  null
  
)

export default component.exports